<template>
  <div>
    <p class="body1 mb-4" data-testid="send-message-description">
      {{ $t("modals.sendMessageToAgent.description") }}
    </p>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-textarea
        v-model="localValue.item.metadata.message"
        :label="$t('modals.sendMessageToAgent.messageLabel')"
        :rules="[required()]"
        variant="outlined"
        counter="200"
        maxlength="200"
        rows="4"
        no-resize
        data-testid="send-message-textarea"
      />
    </v-form>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType, ref, watch } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module";
import cloneDeep from "lodash/cloneDeep";
import { required } from "@/_helpers/validators";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  emits: ["update:localValue", "update:valid", "dismissed"],
  setup(props, { emit }) {
    const form = ref();
    const valid = ref(true);

    const localValue = ref({
      item: {
        ...cloneDeep(props.config.item),
        metadata: { message: "" },
      },
    });

    watch(
      localValue,
      (newVal) => {
        emit("update:localValue", newVal);
      },
      { deep: true, immediate: true }
    );

    watch(valid, (value) => {
      if (value === null) {
        return;
      }
      emit("update:valid", value);
    });

    const validate = async () => {
      const { valid } = await form.value.validate();
      return valid;
    };

    return {
      valid,
      form,
      localValue,
      validate,
      required,
    };
  },
});
</script>
